// -----------------------------------------------------------
// FloraIQ — Aba Correções Assistidas
// -----------------------------------------------------------

import { useState } from "react";
import { correctionTasks } from "@/mocks/quality";
import CorrectionWizard from "./CorrectionWizard";

export default function AssistedCorrectionsPanel() {
  const [wizardOpen, setWizardOpen] = useState(false);
  const [selectedTask, setSelectedTask] = useState({ title: "", quantity: 0 });

  const handleStartCorrection = (task: typeof correctionTasks[0]) => {
    setSelectedTask({ title: task.titulo, quantity: task.quantidade });
    setWizardOpen(true);
  };

  const impactoGeral = correctionTasks.reduce((acc, t) => {
    const pct = parseFloat(t.impacto.replace(/[^0-9.]/g, ""));
    return acc + (isNaN(pct) ? 0 : pct);
  }, 0);

  return (
    <div className="space-y-6">
      {/* Info header */}
      <div className="bg-blue-50/60 border border-blue-200/60 rounded-card p-4">
        <div className="flex items-start gap-3">
          <div className="w-8 h-8 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0 mt-0.5">
            <i className="ri-lightbulb-line text-blue-600"></i>
          </div>
          <div>
            <p className="text-sm font-medium text-blue-800 mb-1">Correções Assistidas</p>
            <p className="text-xs text-blue-600">
              Selecione uma tarefa abaixo para iniciar o wizard de correção em lote. Impacto potencial total na qualidade: <strong>+{impactoGeral.toFixed(1)}%</strong>
            </p>
          </div>
        </div>
      </div>

      {/* Grid de tarefas */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
        {correctionTasks.map((task) => (
          <div key={task.id} className="bg-white rounded-card border border-background-200/70 p-4 hover:border-background-300/60 transition-all duration-200 flex flex-col">
            <div className="flex items-start gap-3 mb-3">
              <div className="w-9 h-9 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                <i className={`${task.icon} text-blue-600 text-sm`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h4 className="text-sm font-medium text-foreground-800 mb-0.5">{task.titulo}</h4>
                <div className="flex items-center gap-3 text-xs text-foreground-500">
                  <span><strong className="text-foreground-700">{task.quantidade.toLocaleString("pt-BR")}</strong> registros</span>
                  <span className="text-green-600">{task.impacto}</span>
                </div>
              </div>
            </div>
            <div className="flex items-center justify-between mt-auto pt-3 border-t border-background-100">
              <span className="text-xs text-foreground-500">{task.tempoEstimado}</span>
              <button
                onClick={() => handleStartCorrection(task)}
                className="btn-primary text-xs px-3 py-1.5 cursor-pointer whitespace-nowrap"
              >
                Iniciar Correção
              </button>
            </div>
          </div>
        ))}
      </div>

      <CorrectionWizard
        isOpen={wizardOpen}
        onClose={() => setWizardOpen(false)}
        taskTitle={selectedTask.title}
        quantity={selectedTask.quantity}
      />
    </div>
  );
}